module.exports = __webpack_public_path__ + "static/img/uni.7018d925.svg";